import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as log from '../util/log';
import { storableError } from '../util/errors';
import { addMarketplaceEntities } from './marketplaceData.duck';
import { fetchLandingListingsFromApi } from '../util/api';
import { reviveSdkJson } from '../util/reviveSdkJson';

const fetchLandingAssetListingsPayloadCreator = async (arg, thunkAPI) => {
  const { rejectWithValue, dispatch } = thunkAPI;
  const { listingFields } = arg;

  return fetchLandingListingsFromApi()
    .then(payload => {
      const revived = reviveSdkJson(payload);
      const sdkResponse = { data: revived };
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(sdkResponse, sanitizeConfig));
      return sdkResponse;
    })
    .catch(error => {
      log.error(error, 'landing-asset-listings-fetch-failed');
      return rejectWithValue(
        storableError({
          message: error.message || 'Failed to load listings',
          status: error.status,
          statusText: error.statusText,
        })
      );
    });
};

export const fetchLandingAssetListings = createAsyncThunk(
  'landingAssetListings/fetch',
  fetchLandingAssetListingsPayloadCreator
);

const landingAssetListingsSlice = createSlice({
  name: 'landingAssetListings',
  initialState: {
    listingIds: [],
    fetched: false,
    inProgress: false,
    error: null,
    forbidden: false,
  },
  reducers: {
    resetLandingAssetListings: state => {
      state.listingIds = [];
      state.fetched = false;
      state.inProgress = false;
      state.error = null;
      state.forbidden = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchLandingAssetListings.pending, state => {
        state.inProgress = true;
        state.error = null;
        state.forbidden = false;
      })
      .addCase(fetchLandingAssetListings.fulfilled, (state, action) => {
        state.inProgress = false;
        state.fetched = true;
        state.listingIds = action.payload.data.data.map(listing => listing.id);
      })
      .addCase(fetchLandingAssetListings.rejected, (state, action) => {
        state.inProgress = false;
        state.fetched = true;
        state.error = action.payload;
        state.forbidden = action.payload?.status === 403;
      });
  },
});

export const { resetLandingAssetListings } = landingAssetListingsSlice.actions;
export default landingAssetListingsSlice.reducer;
